import React, { useEffect, useState } from 'react'
import Layout from '../Layout'
import { Box, Button, CircularProgress, Container, Grid, Paper, TextField, Tooltip, Typography, makeStyles } from '@material-ui/core'
import EditIcon from '@material-ui/icons/Edit';
import { useNavigate } from 'react-router-dom'
import CustomBreadcrumbs from '../Breadcrumb'
import InfoIcon from '@material-ui/icons/Info';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import { useDispatch } from 'react-redux';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { addNotificationTemplate, editeNotificationTemplate, editNotificationTemplate, getNotificationTemplate } from '../../ReduxStore/NotificationSlice'

const useStyles = makeStyles((theme) => ({
    root: {
        padding: theme.spacing(4),
        maxWidth: 1100,
        margin: '0 auto',
        paddingBlock: 30,
        marginTop: 10,
        marginBottom: 10
    },
    form: {
        display: 'flex',
        flexDirection: 'column',
    },
    formControl: {
        marginBottom: theme.spacing(2),
    },
    button: {
        marginTop: theme.spacing(2),
    }
}));



const AddTemplate = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const classes = useStyles();

    const breadcrumbsLinks = [
        { label: 'Home', href: '/' },
        { label: 'Settings', href: '/settings' },
        { label: 'Mail Management', href: '/mail-management' }
    ];

    const [loadings, setLoading] = useState(true);
    const [notificationTemplates, setTemaplates] = useState([]);
    const [templateId, setTemaplateId] = useState(null);
    const [postLoading, setPostLoading] = useState(false);
    const [formData, setFormData] = useState({
        name: '',
        subject: '',
        template: ''
    });

    // Handle input changes
    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData({
            ...formData,
            [name]: value,
        });
    };



    const handleSubmit = async (e) => {
        e.preventDefault();
        setPostLoading(true)

        // Extract variables from the template field in formData
        const templateText = formData.template || "";
        const variableRegex = /{{\s*(\w+)\s*}}/g;
        const extractedVariables = {};
        let match;

        // Loop to find all matches in the template
        while ((match = variableRegex.exec(templateText)) !== null) {
            const variableName = match[1];
            extractedVariables[variableName] = "mock"; // Set default values, or let user specify them
        }

        if (templateId) {
            const payload = {
                customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                template_id: templateId,
                template: formData.template
            };

            console.log("Payload:", payload);
            try {
                const action = dispatch(editNotificationTemplate(payload));
                const res = await action.unwrap();
                console.log("res", res.result)
                if (res.result) {
                    setPostLoading(false)
                    getTemplates(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`);
                    toast.success("Notification Template edited!");
                    setFormData({
                        name: '',
                        subject: '',
                        template: ''
                    })
                    // setTimeout(() => {
                    //     navigate("/user-management")
                    // }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        }
        else {
            const payload = {
                customer_id: "af33f9117ecb4d8d8def84d6331eebd4",
                subject: formData.subject,
                template: formData.template,
                name: formData.name,
                ...extractedVariables, // Add extracted variables to the payload
            };

            console.log("Payload:", payload);
            try {
                const action = dispatch(addNotificationTemplate(payload));
                const res = await action.unwrap();
                console.log("res", res.result)
                if (res.result) {
                    setPostLoading(false)
                    toast.success("Notification Template added!");
                    setFormData({
                        name: '',
                        subject: '',
                        template: ''
                    })
                    getTemplates(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`);
                    // setTimeout(() => {
                    //     navigate("/user-management")
                    // }, 2000);
                }
            } catch (error) {
                console.error("Error in okHandler:", error);
                toast.error(error.message || "Something went wrong!");
            } finally {
                setPostLoading(false)
            }
        }
    };

    const getTemplates = async (param) => {
        try {
            const action = dispatch(getNotificationTemplate(param));
            const res = await action.unwrap();
            console.log("notificationTemplates--", res.result);
            if (res.result) {
                if (param.includes("template_id")) {
                    console.log("edite----------------")
                    setTemaplates(res.result.notification_template);
                    const template = res.result.notification_template[0]; // Assuming you only need the first user in the array

                    // Prefill the form data
                    setFormData({
                        name: template.name || '',
                        subject: template.subject || '',
                        template: template.template || ''
                    });
                } else {
                    setTemaplates(res.result.notification_template);
                }

            };
        } catch (error) {
            console.error("Error in okHandler:", error);
            toast.error(error.message || "No Logs Found!");
        }
    }

    const handleEdit = (item) => {
        setTemaplateId(item.id)
    }

    useEffect(() => {
        const fetchData = async () => {
            await getTemplates(`?customer_id=af33f9117ecb4d8d8def84d6331eebd4`);
            setLoading(false);
        };
        fetchData();
    }, [])


    useEffect(() => {
        if (templateId) {
            getTemplates(`?template_id=${templateId}`);
        }
    }, [templateId])




    return (
        <Layout>
            <Container>
                {/* <Box mt={1}>
                    <ResponsiveTypography>
                        Add Templates
                    </ResponsiveTypography>
                </Box> */}
                <Box mt={1} mb={3}>
                    <CustomBreadcrumbs links={breadcrumbsLinks} current="Add Templates" />
                </Box>
                <Box>
                    <Paper className={classes.root}>
                        <form className={classes.form} onSubmit={handleSubmit} >
                            <Grid container spacing={3} >
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Name"
                                        name="name"
                                        variant="outlined"
                                        required
                                        fullWidth
                                        value={formData.name}
                                        onChange={handleInputChange}
                                    />
                                </Grid>
                                <Grid item xs={12} sm={6}>
                                    <TextField
                                        label="Subject"
                                        name="subject"
                                        variant="outlined"
                                        fullWidth
                                        value={formData.subject}
                                        onChange={handleInputChange}
                                        required
                                    />
                                </Grid>
                                {/* <Grid item xs={12}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Template"
                                        name="template"
                                        variant="outlined"
                                        fullWidth
                                        required
                                        value={formData.template}
                                        multiline
                                        rows={4}
                                    />
                                </Grid> */}
                                <Grid item xs={12}>
                                    <TextField
                                        className={classes.formControl}
                                        label="Template"
                                        name="template"
                                        variant="outlined"
                                        fullWidth
                                        required
                                        value={formData.template}
                                        onChange={handleInputChange}
                                        multiline
                                        rows={4}
                                        placeholder="Use {{variable}} format for dynamic content, e.g., {{ machineName }}, {{ asset_id }}."
                                    />
                                    <Box mt={1} display="flex" alignItems="center">
                                        <Tooltip title="Use double curly braces for dynamic content, e.g., {{ machineName }}, {{ asset_id }}.">
                                            <InfoIcon color="action" style={{ marginRight: 8 }} />
                                        </Tooltip>
                                        <Typography variant="body2" color="textSecondary">
                                            Example:<p>Hi,</p><p>A downtime has been reported on <b>Asset No and Asset Description</b> with ID: Asset Id</p>
                                        </Typography>
                                    </Box>
                                </Grid>
                            </Grid>
                            <Grid container spacing={3}>
                                <Grid item xs={12} sm={4}>
                                    <Button
                                        className={classes.button}
                                        type="submit"
                                        variant="contained"
                                        style={{ backgroundColor: 'green', color: 'white' }}
                                        fullWidth
                                        startIcon={postLoading ? <CircularProgress size={20} /> : <CheckCircleIcon />}
                                        disabled={postLoading}
                                    >
                                        {postLoading ? "Adding Template" : "Add Template"}
                                    </Button>
                                </Grid>
                            </Grid>
                        </form>
                    </Paper>
                </Box>
                <Box className="add-checkpoint">
                    <Grid container className='row1' spacing={3}>
                        <Grid item xs={12} sm={3}>
                            <Typography variant="body1" style={{ fontSize: '16px', fontWeight: 500 }}>
                                Notification Templates
                            </Typography>
                        </Grid>
                    </Grid>
                    <Grid container spacing={3} alignItems='center'>
                        <Grid item xs={2} sm={1}>
                            <h4>Sr.no.</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>Name</h4>
                        </Grid>
                        <Grid item xs={3} sm={3}>
                            <h4>Subject</h4>
                        </Grid>
                        <Grid item xs={3} sm={4}>
                            <h4>Template</h4>
                        </Grid>
                        <Grid item xs={3} sm={2}>
                            <h4>Action</h4>
                        </Grid>
                    </Grid>
                    <hr />
                    {loadings ? (
                        <Box display="flex" justifyContent="center" alignItems="center" mt={2}>
                            <CircularProgress />
                        </Box>
                    ) : (
                        notificationTemplates.length > 0 && notificationTemplates.map((item, index) => (
                            <Grid container spacing={3} key={index} alignItems='center'>
                                <Grid item xs={2} sm={1}>
                                    {index + 1}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    {item.name}
                                </Grid>
                                <Grid item xs={3} sm={3}>
                                    {item.subject}
                                </Grid>
                                <Grid item xs={3} sm={4}>
                                    {item.template}
                                </Grid>
                                <Grid item xs={3} sm={2}>
                                    <button
                                        style={{
                                            background: 'none',
                                            border: 'none',
                                            cursor: 'pointer',
                                            color: '#3f51b5',
                                            marginRight: '8px',
                                        }}
                                        onClick={() => handleEdit(item)}
                                    >
                                        <EditIcon />
                                    </button>
                                </Grid>
                            </Grid>
                        ))
                    )}
                    <hr />
                </Box>
            </Container>
            <ToastContainer />
        </Layout >
    )
}

export default AddTemplate